/* eslint-disable */
// GENERATED by scripts/shipping/build-courier-zones.mjs from Atlasship's zone
// API (pickup 560076): 4652 delivery PINs across 403 prefixes. Do not edit by hand.
// Exceptions are concatenated 6-digit PINs.
export const COURIER_ZONE_BY_PREFIX = {
    "110": "C2",
    "121": "D2",
    "122": "D2",
    "123": "D2",
    "124": "D2",
    "125": "D2",
    "126": "D2",
    "127": "D2",
    "131": "D2",
    "132": "D2",
    "133": "D2",
    "134": "D2",
    "135": "D2",
    "136": "D2",
    "140": "D2",
    "141": "D2",
    "142": "D2",
    "143": "D2",
    "144": "D2",
    "145": "D2",
    "146": "D2",
    "147": "D2",
    "148": "D2",
    "151": "D2",
    "152": "D2",
    "160": "D2",
    "171": "E",
    "172": "E",
    "173": "E",
    "174": "E",
    "175": "E",
    "176": "E",
    "177": "E",
    "180": "E",
    "181": "E",
    "182": "E",
    "184": "E",
    "185": "E",
    "190": "F",
    "191": "F",
    "192": "F",
    "193": "F",
    "194": "F",
    "201": "D2",
    "202": "D2",
    "203": "D2",
    "204": "D2",
    "205": "D2",
    "206": "D2",
    "207": "D2",
    "208": "D2",
    "209": "D2",
    "210": "D2",
    "211": "D2",
    "212": "D2",
    "221": "D2",
    "222": "D2",
    "223": "D2",
    "224": "D2",
    "225": "D2",
    "226": "D2",
    "227": "D2",
    "228": "D2",
    "229": "D2",
    "230": "D2",
    "231": "D2",
    "232": "D2",
    "233": "D2",
    "241": "D2",
    "242": "D2",
    "243": "D2",
    "244": "D2",
    "245": "D2",
    "246": "D2",
    "247": "D2",
    "248": "D2",
    "249": "D2",
    "250": "D2",
    "251": "D2",
    "261": "D2",
    "262": "D2",
    "263": "D2",
    "271": "D2",
    "272": "D2",
    "273": "D2",
    "274": "D2",
    "275": "D2",
    "276": "D2",
    "277": "D2",
    "281": "D2",
    "282": "D2",
    "283": "D2",
    "284": "D2",
    "285": "D2",
    "301": "D2",
    "302": "D2",
    "303": "D2",
    "304": "D2",
    "305": "D2",
    "306": "D2",
    "307": "D2",
    "311": "D2",
    "312": "D2",
    "313": "D2",
    "314": "D2",
    "321": "D2",
    "322": "D2",
    "323": "D2",
    "324": "D2",
    "325": "D2",
    "326": "D2",
    "327": "D2",
    "328": "D2",
    "331": "D2",
    "332": "D2",
    "333": "D2",
    "334": "D2",
    "335": "D2",
    "341": "D2",
    "342": "D2",
    "343": "D2",
    "344": "D2",
    "345": "D2",
    "360": "D2",
    "361": "D2",
    "362": "D2",
    "363": "D2",
    "364": "D2",
    "365": "D2",
    "370": "D2",
    "380": "D1",
    "382": "D2",
    "383": "D2",
    "384": "D2",
    "385": "D2",
    "387": "D1",
    "388": "D2",
    "389": "D2",
    "390": "D1",
    "391": "D1",
    "392": "D1",
    "393": "D1",
    "394": "D1",
    "395": "D1",
    "396": "D1",
    "400": "C1",
    "401": "D1",
    "402": "D1",
    "403": "D1",
    "410": "D1",
    "411": "C1",
    "412": "D1",
    "413": "D1",
    "414": "D1",
    "415": "D1",
    "416": "D1",
    "421": "D1",
    "422": "D1",
    "423": "D1",
    "424": "D1",
    "425": "D1",
    "431": "D1",
    "440": "D1",
    "441": "D1",
    "442": "D1",
    "443": "D1",
    "444": "D1",
    "445": "D1",
    "450": "D1",
    "451": "D1",
    "452": "D1",
    "453": "D1",
    "454": "D1",
    "455": "D1",
    "456": "D1",
    "457": "D2",
    "458": "D2",
    "460": "D1",
    "461": "D1",
    "462": "D2",
    "463": "D2",
    "464": "D2",
    "465": "D2",
    "466": "D2",
    "470": "D2",
    "471": "D2",
    "472": "D2",
    "473": "D2",
    "474": "D2",
    "475": "D2",
    "476": "D2",
    "477": "D2",
    "480": "D1",
    "481": "D1",
    "482": "D1",
    "483": "D2",
    "484": "D2",
    "485": "D2",
    "486": "D2",
    "487": "D1",
    "488": "D2",
    "490": "D1",
    "491": "D1",
    "492": "D2",
    "493": "D2",
    "494": "D1",
    "495": "D2",
    "496": "D2",
    "497": "D2",
    "500": "C1",
    "501": "D1",
    "502": "D1",
    "503": "D1",
    "504": "D1",
    "505": "D1",
    "506": "D1",
    "507": "D1",
    "508": "D1",
    "509": "D1",
    "515": "B",
    "516": "B",
    "517": "B",
    "518": "B",
    "520": "D1",
    "521": "D1",
    "522": "D1",
    "523": "D1",
    "524": "B",
    "530": "D1",
    "531": "D1",
    "532": "D1",
    "533": "D1",
    "534": "D1",
    "535": "D1",
    "560": "A",
    "561": "B",
    "562": "B",
    "563": "B",
    "570": "B",
    "571": "B",
    "572": "B",
    "573": "B",
    "574": "B",
    "575": "B",
    "576": "B",
    "577": "B",
    "580": "B",
    "581": "D1",
    "582": "B",
    "583": "B",
    "584": "B",
    "585": "D1",
    "586": "D1",
    "587": "D1",
    "590": "D1",
    "591": "D1",
    "600": "B",
    "601": "B",
    "602": "B",
    "603": "B",
    "604": "B",
    "605": "B",
    "606": "B",
    "607": "B",
    "608": "B",
    "609": "B",
    "610": "B",
    "611": "B",
    "612": "B",
    "613": "B",
    "614": "B",
    "620": "B",
    "621": "B",
    "622": "B",
    "623": "D1",
    "624": "B",
    "625": "B",
    "626": "D1",
    "627": "D1",
    "628": "D1",
    "629": "D1",
    "630": "B",
    "631": "B",
    "632": "B",
    "635": "B",
    "636": "B",
    "637": "B",
    "638": "B",
    "639": "B",
    "641": "B",
    "642": "B",
    "643": "B",
    "670": "B",
    "671": "B",
    "673": "B",
    "676": "B",
    "678": "B",
    "679": "B",
    "680": "B",
    "682": "E",
    "683": "D1",
    "685": "D1",
    "686": "D1",
    "688": "D1",
    "689": "D1",
    "690": "D1",
    "691": "D1",
    "695": "D1",
    "700": "D2",
    "711": "D2",
    "712": "D2",
    "713": "D2",
    "721": "D2",
    "722": "D2",
    "723": "D2",
    "731": "D2",
    "732": "D2",
    "733": "D2",
    "734": "D2",
    "735": "D2",
    "736": "D2",
    "737": "E",
    "741": "D2",
    "742": "D2",
    "743": "D2",
    "744": "F",
    "751": "D2",
    "752": "D2",
    "753": "D2",
    "754": "D2",
    "755": "D2",
    "756": "D2",
    "757": "D2",
    "758": "D2",
    "759": "D2",
    "760": "D1",
    "761": "D1",
    "762": "D2",
    "763": "D1",
    "764": "D1",
    "765": "D1",
    "766": "D1",
    "767": "D2",
    "768": "D2",
    "769": "D2",
    "770": "D2",
    "781": "E",
    "782": "E",
    "783": "E",
    "784": "E",
    "785": "E",
    "786": "E",
    "787": "E",
    "788": "E",
    "790": "E",
    "791": "E",
    "792": "E",
    "793": "E",
    "794": "E",
    "795": "F",
    "796": "E",
    "797": "E",
    "798": "E",
    "799": "E",
    "800": "D2",
    "801": "D2",
    "802": "D2",
    "803": "D2",
    "804": "D2",
    "805": "D2",
    "811": "D2",
    "812": "D2",
    "813": "D2",
    "814": "D2",
    "815": "D2",
    "816": "D2",
    "821": "D2",
    "822": "D2",
    "823": "D2",
    "824": "D2",
    "825": "D2",
    "826": "D2",
    "827": "D2",
    "828": "D2",
    "829": "D2",
    "831": "D2",
    "832": "D2",
    "833": "D2",
    "834": "D2",
    "835": "D2",
    "841": "D2",
    "842": "D2",
    "843": "D2",
    "844": "D2",
    "845": "D2",
    "846": "D2",
    "847": "D2",
    "848": "D2",
    "851": "D2",
    "852": "D2",
    "853": "D2",
    "854": "D2",
    "855": "D2"
};
export const COURIER_ZONE_EXCEPTIONS = {
    "C2": "121001121002121003121004121005121006121007121008121009121010121012121013121101122001122002122003122004122005122006122007122008122009122010122011122015122016122017122018122050122051122052122101122102122103122105122109122211122413122414122503122504122505122506123035123110123413123503123504123505123506123508124101124102124103124104124105124107124108124109124139124201124202124203124504124517131001131021131022131023131024131027131028131029131030131039131101131102131103131402131403131408131409201001201002201003201004201005201006201007201009201010201011201012201013201014201016201017201019201102201103201301201303201304201305201306201307201309201310201312201313380001380002380003380004380005380006380007380008380009380013380014380015380016380018380019380021380022380023380024380025380026380027380028380050380051380052380054380055380058380059380060380061380063382006382007382009382010382016382017382019382020382021382022382023382024382028382029382030382041382042382043382045382110382115382210382213382220382225382240382260382305382308382315382320382321382325382330382340382345382350382355382405382410382415382418382421382422382423382424382425382426382427382428382430382433382435382440382443382445382449382470382475382480382481382610382620382630382640382650382655382721382725382729382735382740382743382835382845382855700001700002700003700004700005700006700007700008700009700010700011700012700013700014700015700016700017700018700019700020700021700022700023700024700025700026700027700028700029700030700031700032700033700034700035700036700037700038700039700040700041700042700043700044700045700046700047700048700049700050700051700052700053700054700055700056700057700058700059700060700061700062700063700064700065700066700067700068700069700070700071700072700073700074700075700076700077700078700079700080700081700082700083700084700085700086700087700088700089700090700091700092700093700094700095700096700097700098700099700100700101700102700103700104700105700106700107700108700109700110700111700112700113700114700115700116700129700130700131700132700133700134700135700136700137700138700139700140700141700142700143700144700145700146700147700148700149700150700151700152700153700154700156700157700158700159700160711101711102711103711104711105711106711107711108711109711110711111711112711113711114711201711202711203711204711205711224711227711301711302711303711304711305711306711307711308711309711310711311711312711313711314711315711316711317711322711324711401711402711403711404711405711409711411711413712101712102712103712104712105712121712123712124712125712136712137712138712139712146712147712148712149712154712201712202712203712204712221712222712223712232712233712234712235712245712246712247712248712249712250712258712304712305712306712310712311712426712501712502712503712504712513712514712515712702712704712708741221741234741235741245741246741249741250741251741252741257743290743318743330743331743332743363743368743375743376743377743384743387743389743398743399743503743504743513743610743613743711",
    "E": "194102194103194104194105194106194109194201194302",
    "D1": "327602327606327801388001388110388120388121388122388130388132388140388150388160388170388180388205388210388215388220388225388230388245388250388305388306388307388310388315388320388325388330388335388340388345388350388355388360388365388370388410388421388440388450388460388465388470388480388510388515388520388530388540388543388544388545388550388560388570388580388590388610389130389140389146389151389152389154389155389156389157389160389170389180389190389310389320389325389330389350389352389360389365389370389380389382389390457001457222457441457550457551457552457661457770457772457773457775457777457779457882457885457887457888457893457990457993464665464668464670464671464774464986464990464993466113466114466116466117466118466119466120466125466221466331466445466446466448466554470223470226470880470881483001483053483105483113483119483220483222483225483332483334483336492001492002492003492004492005492007492008492009492010492012492013492014492015492099492101492109493101493111493113493114493116493118493195493196493221493225493228493229493330493331493332493441493445493448493449493526493551493562493661493662493663493770493773493776493778493881493885493887493888493889493890493891493895493992493996682001682002682003682004682005682006682007682008682009682010682011682012682013682014682015682016682017682018682019682020682021682022682023682024682025682026682027682028682029682030682031682032682033682034682035682036682037682038682039682040682041682042682301682302682303682304682305682306682307682308682309682310682311682312682313682314682315682316682320682501682502682503682504682505682506682507682508682509682511752017752018752019752021752022752023752024752025752026752027752028752029752030752031752032752034752035752037752038752066752068752069752070752079752080752081752082752083752084752085752087752089752090752091752092752093752094762022762028762100762102762103762104762105762107762109762110762112767001767002767024767026767029767030767032767033767035767037767039767040767042767046767060767065767066767067767070",
    "C1": "401101401105401106401107401201401202401203401204401206401207401208401209401301401302401303401304401305410101410201410206410207410208410209410210410216410218410220410221410222410501410505410506410507410510410513412101412105412108412109412112412115412201412207412307412308412404421001421002421004421005421102421103421201421202421203421204421301421302421303421304421305421306421308421311421312421501421502421503421504421505421506421605501106501202501203501218501301501401501503501504501505501506501508501510501511501512502001502032502205502210502280502284502285502291502294502295502296502300502305502306502307502319502324502325502329502336509218",
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
    "A": "561201562106562107562109562114562122562123562125562128562129562130562149562157562159562162562164"
};
export const FREIGHT_ZONE_BY_PREFIX = {
    "110": "N1",
    "121": "N1",
    "122": "N1",
    "123": "N1",
    "124": "N1",
    "125": "N1",
    "126": "N1",
    "127": "N1",
    "131": "N1",
    "132": "N1",
    "133": "N2",
    "134": "N2",
    "135": "N1",
    "136": "N1",
    "140": "N2",
    "141": "N2",
    "142": "N2",
    "143": "N2",
    "144": "N2",
    "145": "N2",
    "146": "N2",
    "147": "N2",
    "148": "N2",
    "151": "N2",
    "152": "N2",
    "160": "N2",
    "171": "N2",
    "172": "N2",
    "173": "N2",
    "174": "N2",
    "175": "N2",
    "176": "N2",
    "177": "N2",
    "180": "N2",
    "181": "N2",
    "182": "N2",
    "184": "N2",
    "185": "N2",
    "190": "N2",
    "191": "N2",
    "192": "N2",
    "193": "N2",
    "201": "N1",
    "202": "N1",
    "203": "N1",
    "204": "N1",
    "205": "N1",
    "206": "N1",
    "207": "N1",
    "208": "N1",
    "209": "N1",
    "210": "N1",
    "211": "N1",
    "212": "N1",
    "221": "N1",
    "222": "N1",
    "223": "N1",
    "224": "N1",
    "225": "N1",
    "226": "N1",
    "227": "N1",
    "228": "N1",
    "229": "N1",
    "230": "N1",
    "231": "N1",
    "232": "N1",
    "233": "N1",
    "241": "N1",
    "242": "N1",
    "243": "N1",
    "244": "N1",
    "245": "N1",
    "246": "N2",
    "247": "N2",
    "248": "N2",
    "249": "N2",
    "250": "N1",
    "251": "N1",
    "261": "N1",
    "262": "N2",
    "263": "N2",
    "271": "N1",
    "272": "N1",
    "273": "N1",
    "274": "N1",
    "275": "N1",
    "276": "N1",
    "277": "N1",
    "281": "N1",
    "282": "N1",
    "283": "N1",
    "284": "N1",
    "285": "N1",
    "301": "N1",
    "302": "N1",
    "303": "N1",
    "304": "N1",
    "305": "N1",
    "306": "N1",
    "307": "N1",
    "311": "N1",
    "312": "N1",
    "313": "N1",
    "314": "N1",
    "321": "N1",
    "322": "N1",
    "323": "N1",
    "324": "N1",
    "325": "N1",
    "326": "N1",
    "327": "N1",
    "328": "N1",
    "331": "N1",
    "332": "N1",
    "333": "N1",
    "334": "N1",
    "335": "N1",
    "341": "N1",
    "342": "N1",
    "343": "N1",
    "344": "N1",
    "345": "N1",
    "360": "W1",
    "361": "W1",
    "362": "W1",
    "363": "W1",
    "364": "W1",
    "365": "W1",
    "370": "W1",
    "380": "W1",
    "382": "W1",
    "383": "W1",
    "384": "W1",
    "385": "W1",
    "387": "W1",
    "388": "W1",
    "389": "W1",
    "390": "W1",
    "391": "W1",
    "392": "W1",
    "393": "W1",
    "394": "W1",
    "395": "W1",
    "396": "W1",
    "400": "W2",
    "401": "W2",
    "402": "W2",
    "403": "W2",
    "410": "W2",
    "411": "W2",
    "412": "W2",
    "413": "W2",
    "414": "W2",
    "415": "W2",
    "416": "W2",
    "421": "W2",
    "422": "W2",
    "423": "W2",
    "424": "W2",
    "425": "W2",
    "431": "W2",
    "440": "W2",
    "441": "W2",
    "442": "W2",
    "443": "W2",
    "444": "W2",
    "445": "W2",
    "450": "Central",
    "451": "Central",
    "452": "Central",
    "453": "Central",
    "454": "Central",
    "455": "Central",
    "456": "Central",
    "457": "Central",
    "458": "Central",
    "460": "Central",
    "461": "Central",
    "462": "Central",
    "463": "Central",
    "464": "Central",
    "465": "Central",
    "466": "Central",
    "470": "Central",
    "471": "Central",
    "472": "Central",
    "473": "Central",
    "474": "Central",
    "475": "Central",
    "476": "Central",
    "477": "Central",
    "480": "Central",
    "481": "Central",
    "482": "Central",
    "483": "Central",
    "484": "Central",
    "485": "Central",
    "486": "Central",
    "487": "Central",
    "488": "Central",
    "490": "Central",
    "491": "Central",
    "492": "Central",
    "493": "Central",
    "494": "Central",
    "495": "Central",
    "496": "Central",
    "497": "Central",
    "500": "S1",
    "501": "S1",
    "502": "S1",
    "503": "S1",
    "504": "S1",
    "505": "S1",
    "506": "S1",
    "507": "S1",
    "508": "S1",
    "509": "S1",
    "515": "S1",
    "516": "S1",
    "517": "S1",
    "518": "S1",
    "520": "S1",
    "521": "S1",
    "522": "S1",
    "523": "S1",
    "524": "S1",
    "530": "S1",
    "531": "S1",
    "532": "S1",
    "533": "S1",
    "534": "S1",
    "535": "S1",
    "560": "S1",
    "561": "S1",
    "562": "S1",
    "563": "S1",
    "570": "S1",
    "571": "S1",
    "572": "S1",
    "573": "S1",
    "574": "S1",
    "575": "S1",
    "576": "S1",
    "577": "S1",
    "580": "S1",
    "581": "S1",
    "582": "S1",
    "583": "S1",
    "584": "S1",
    "585": "S1",
    "586": "S1",
    "587": "S1",
    "590": "S1",
    "591": "S1",
    "600": "S1",
    "601": "S1",
    "602": "S1",
    "603": "S1",
    "604": "S1",
    "605": "S1",
    "606": "S1",
    "607": "S1",
    "608": "S1",
    "609": "S1",
    "610": "S1",
    "611": "S1",
    "612": "S1",
    "613": "S1",
    "614": "S1",
    "620": "S1",
    "621": "S1",
    "622": "S1",
    "623": "N2",
    "624": "S1",
    "625": "S1",
    "626": "S1",
    "627": "S1",
    "628": "S1",
    "629": "S1",
    "630": "S1",
    "631": "S1",
    "632": "S1",
    "635": "S1",
    "636": "S1",
    "637": "S1",
    "638": "S1",
    "639": "S1",
    "641": "S1",
    "642": "S1",
    "643": "S1",
    "670": "S2",
    "671": "S2",
    "673": "S2",
    "676": "S2",
    "678": "S2",
    "679": "S2",
    "680": "S2",
    "682": "S2",
    "683": "S2",
    "685": "S2",
    "686": "S2",
    "688": "S2",
    "689": "S2",
    "690": "S2",
    "691": "S2",
    "695": "S2",
    "700": "E",
    "711": "E",
    "712": "E",
    "713": "E",
    "721": "E",
    "722": "E",
    "723": "E",
    "731": "E",
    "732": "E",
    "733": "E",
    "734": "E",
    "735": "E",
    "736": "E",
    "737": "NE",
    "741": "E",
    "742": "E",
    "743": "E",
    "751": "E",
    "752": "E",
    "753": "E",
    "754": "E",
    "755": "E",
    "756": "E",
    "757": "E",
    "758": "E",
    "759": "E",
    "760": "E",
    "761": "E",
    "762": "E",
    "763": "E",
    "764": "E",
    "765": "E",
    "766": "E",
    "767": "E",
    "768": "E",
    "769": "E",
    "770": "E",
    "781": "NE",
    "782": "NE",
    "783": "NE",
    "784": "NE",
    "785": "NE",
    "786": "NE",
    "787": "NE",
    "788": "NE",
    "790": "NE",
    "791": "NE",
    "792": "NE",
    "793": "NE",
    "794": "NE",
    "795": "NE",
    "796": "NE",
    "797": "NE",
    "798": "NE",
    "799": "NE",
    "800": "E",
    "801": "E",
    "802": "E",
    "803": "E",
    "804": "E",
    "805": "E",
    "811": "E",
    "812": "E",
    "813": "E",
    "814": "E",
    "815": "E",
    "816": "E",
    "821": "E",
    "822": "E",
    "823": "E",
    "824": "E",
    "825": "E",
    "826": "E",
    "827": "E",
    "828": "E",
    "829": "E",
    "831": "E",
    "832": "E",
    "833": "E",
    "834": "E",
    "835": "E",
    "841": "E",
    "842": "E",
    "843": "E",
    "844": "E",
    "845": "E",
    "846": "E",
    "847": "E",
    "848": "E",
    "851": "E",
    "852": "E",
    "853": "E",
    "854": "E",
    "855": "E"
};
export const FREIGHT_ZONE_EXCEPTIONS = {
    "N1": "133103133105133201133202133203133204133205133206133207133301133302246764247001247451247778262001262908",
    "S1": "623003623004623005623102623104623115623120623135623207623208623308623309623315623401623402623403623404623406623407623409623501623502623503623504623512623513623514623515623516623517623518623519623520623521623522623523623524623525623526623527623528623529623530623531623532623533623534623535623536623537623538623566623601623603623604623605623608623701623703623704623705623706623707623708623711623712623804623806"
};
export const COURIER_ZONE_CEILING_BY_FREIGHT_ZONE = {
    "N1": "D2",
    "N2": "F",
    "W1": "D2",
    "W2": "D1",
    "Central": "D2",
    "S1": "D1",
    "S2": "D1",
    "E": "D2",
    "NE": "F"
};
//# sourceMappingURL=shippingZones.generated.js.map